<template>
  <login-component></login-component>
</template>

<script>
import LoginComponent from "@/components/utils/LoginComponent.vue";

export default {
  name: "LoginView",

  components: {
    LoginComponent,
  },
};
</script>
